import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { fmt, Chip, Tabs } from "./kit";

/// Kullanici / yayinci detay sayfasinin alt bolumu: uygulamadaki her ozellik tek yerde.
const REL = { best_friend: "En iyi arkadaş", brother: "Erkek kardeş", sister: "Kız kardeş", cp: "CP" };
const LOGIN = { 0: "Hızlı giriş", 1: "Google", 2: "E-posta", 3: "Apple", 4: "Facebook" };

const day = (d) => (d ? new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
const dt = (d) => (d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

const Row = ({ k, v }) => (
  <div className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid var(--badu-line-soft)", gap: 12 }}>
    <span style={{ fontSize: 13, color: "var(--badu-sub)" }}>{k}</span>
    <span style={{ fontSize: 13.5, fontWeight: 600, color: "var(--badu-ink)", textAlign: "right", wordBreak: "break-all" }}>{v ?? "—"}</span>
  </div>
);

const Box = ({ title, children }) => (
  <div className="col-12 col-lg-6 mb-4">
    <div className="badu-tile" style={{ height: "100%" }}>
      <div className="badu-lbl mb-2">{title}</div>
      {children}
    </div>
  </div>
);

const Empty = ({ t = "Yok" }) => <div style={{ fontSize: 13, color: "var(--badu-sub)", padding: "8px 0" }}>{t}</div>;

const User360 = ({ id }) => {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("genel");

  useEffect(() => {
    if (!id) return;
    api.user360(id).then((r) => r?.status && setD(r));
  }, [id]);

  // onay sormadan yasaklar (sureli degil), sonra listeyi yeniler
  const ban = async (kind, value, mevcut) => {
    // yasak varsa ayni dugme yasagi kaldirir
    const r = mevcut ? await api.banRemove(mevcut._id) : await api.banAdd({ kind, value, reason: "Admin panelinden", days: 0 });
    if (!r?.status) window.alert(r?.message || "Olmadı.");
    api.user360(id).then((x) => x?.status && setD(x));
  };

  if (!d) return <div className="badu-empty">Detaylar yükleniyor…</div>;
  const { account: a, economy: e, levels: l, vip, social: s, security, recent } = d;

  return (
    <div className="mt-2">
      <Tabs
        value={tab}
        onChange={setTab}
        tabs={[
          ["genel", "Genel"],
          ["ekonomi", "Ekonomi"],
          ["sosyal", "Sosyal"],
          ["guvenlik", "Cihaz & Güvenlik"],
          ["hareket", `Son hareketler (${recent.length})`],
        ]}
      />
      <div className="row mt-3">
        {tab === "genel" && (
          <>
            <Box title="Hesap">
              <Row k="Giriş türü" v={LOGIN[a.loginType] || "—"} />
              <Row k="Platform" v={a.platform} />
              <Row k="Son görülme" v={dt(a.lastSeenAt)} />
              <Row k="Durum" v={a.isLive ? <Chip kind="live">Canlı yayında</Chip> : a.isOnline ? <Chip>Çevrimiçi</Chip> : "Çevrimdışı"} />
              <Row k="Yayıncı" v={a.isHost ? "Evet" : "Hayır"} />
            </Box>
            <Box title="Tehlikeli bölge">
              <div style={{ fontSize: 13, color: "var(--badu-sub)", marginBottom: 10 }}>
                Hesabı ve sohbet, bildirim, geçmiş gibi kayıtlarını kalıcı siler. Geri alınamaz.
              </div>
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={async () => {
                  const typed = window.prompt(`${a.name || "Bu hesap"} KALICI silinecek. Onaylamak için kullanıcı ID'sini yazın (${a.uniqueID}):`);
                  if (typed === null) return;
                  const r = await api.userDelete(id, typed.trim());
                  window.alert(r?.message || (r?.status ? "Hesap silindi." : "Silinemedi."));
                  if (r?.status) window.location.reload();
                }}
              >
                Hesabı sil
              </button>
            </Box>
            <Box title="Seviyeler & VIP">
              <Row k="Zenginlik seviyesi" v={l ? `${l.wealth} (${fmt(l.spent)} coin harcadı)` : "—"} />
              <Row k="Çekicilik seviyesi" v={l ? `${l.charm} (${fmt(l.earned)} coin aldı)` : "—"} />
              <Row k="Aktivite seviyesi" v={l?.activity ?? "—"} />
              <Row k="VIP" v={vip ? `VIP${vip.level} · ${day(vip.expiresAt)} tarihine kadar` : "Yok"} />
              <Row k="Sıralamada gizli" v={l?.rankHidden ? "Evet" : "Hayır"} />
              <Row k="Aylık kart" v={s.cards.length ? s.cards.map((c) => `${c.key} (${day(c.expiresAt)})`).join(", ") : "Yok"} />
            </Box>
          </>
        )}

        {tab === "ekonomi" && (
          <>
            <Box title="Bakiye">
              <Row k="Coin" v={fmt(e.coin)} />
              {e.hostCoin !== null && <Row k="Yayıncı hesabı coin" v={fmt(e.hostCoin)} />}
              <Row k="Oyun coini" v={fmt(e.gameCoin)} />
              <Row k="Satın alınan coin (toplam)" v={fmt(e.purchasedCoin)} />
              <Row k="Gönderdiği hediye" v={`${fmt(e.giftSent.coin)} coin · ${e.giftSent.n} kez`} />
              <Row k="Aldığı hediye" v={`${fmt(e.giftReceived.coin)} coin · ${e.giftReceived.n} kez`} />
            </Box>
            <Box title="Satın almalar (Apple / Google)">
              {e.purchases.length ? (
                e.purchases.map((p) => <Row key={p._id} k={p._id === "ios" ? "iPhone" : "Android"} v={`${p.n} işlem · $${fmt(p.amount)} · ${fmt(p.coin)} coin`} />)
              ) : (
                <Empty t="Hiç satın alma yok" />
              )}
              {e.recentPurchases.map((p) => (
                <Row key={p._id} k={dt(p.createdAt)} v={`${p.platform === "ios" ? "iPhone" : "Android"} · ${p.productId} · ${fmt(p.coin)} coin`} />
              ))}
            </Box>
            <div className="col-12 mb-4">
              <div className="badu-tile">
                <div className="badu-lbl mb-2">Coin hareketleri türe göre</div>
                {e.byType.length ? (
                  e.byType.map((t, i) => <Row key={i} k={`${t.label} · ${t.income ? "gelen" : "giden"}`} v={`${fmt(t.coin)} coin · ${t.n} kez`} />)
                ) : (
                  <Empty t="Hareket yok" />
                )}
              </div>
            </div>
          </>
        )}

        {tab === "sosyal" && (
          <>
            <Box title="Takip & aile">
              <Row k="Takipçi" v={fmt(s.followers)} />
              <Row k="Takip ettiği" v={fmt(s.following)} />
              <Row k="Onu engelleyen" v={fmt(s.blockedBy)} />
              <Row k="Aile" v={s.family ? `${s.family.name} (Lv ${s.family.level || 1})` : "Yok"} />
              <Row k="Evlilik" v={s.marriage ? `${s.marriage.partner} · ${s.marriage.ring || ""} · ${day(s.marriage.since)}` : "Yok"} />
              <Row k="Davet eden" v={s.invitedBy || "—"} />
              <Row k="Davet ettiği kişi" v={fmt(s.invitedCount)} />
            </Box>
            <Box title="İlişkiler">
              {s.relations.length ? s.relations.map((r, i) => <Row key={i} k={REL[r.type] || r.type} v={`${r.with} · ${day(r.since)}`} />) : <Empty />}
            </Box>
            <Box title="Koruma & Fan Kulübü">
              {s.guardians.map((g, i) => (
                <Row key={"g" + i} k={g.role === "koruyucusu" ? `${g.other} yayıncısının koruyucusu` : `Koruyucusu: ${g.other}`} v={`Seviye ${g.level} · ${day(g.expiresAt)}`} />
              ))}
              {s.fans.map((f, i) => (
                <Row key={"f" + i} k={f.role === "fanı" ? `${f.other} yayıncısının fanı` : `Fanı: ${f.other}`} v={day(f.expiresAt)} />
              ))}
              {!s.guardians.length && !s.fans.length && <Empty />}
            </Box>
            <Box title="Sesli odaları">
              {s.rooms.length ? (
                s.rooms.map((r) => <Row key={r._id} k={`${r.title || "Oda"}${r.mode === "game" ? " (oyun)" : ""}`} v={`${r.isActive ? "Açık" : "Kapalı"} · ${fmt(r.totalGiftCoin)} coin`} />)
              ) : (
                <Empty />
              )}
            </Box>
          </>
        )}

        {tab === "guvenlik" && (
          <>
            <Box title="Cihaz">
              <Row k="Platform" v={a.platform} />
              <Row k="Cihaz kimliği" v={a.deviceId || "—"} />
              <Row k="Son IP" v={a.lastIp || "—"} />
              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-sm btn-outline-danger" disabled={!a.deviceId} onClick={() => ban("device", a.deviceId, security.bans.find((b) => b.kind === "device" && b.value === a.deviceId))}>{security.bans.find((b) => b.kind === "device" && b.value === a.deviceId) ? "Cihazı yasağını kaldır" : "Cihazı engelle"}</button>
                <button className="btn btn-sm btn-outline-danger" disabled={!a.lastIp} onClick={() => ban("ip", a.lastIp, security.bans.find((b) => b.kind === "ip" && b.value === a.lastIp))}>{security.bans.find((b) => b.kind === "ip" && b.value === a.lastIp) ? "IP yasağını kaldır" : "IP engelle"}</button>
                <button className="btn btn-sm btn-outline-primary" onClick={async () => { const r = await api.gifGrant(id, 30); window.alert(r?.message || (r?.status ? "Verildi" : "Olmadı")); }}>GIF profil ver (30 gün)</button>
              </div>
            </Box>
            <Box title="Cihaz / IP yasağı">
              {security.bans.length ? (
                security.bans.map((b, i) => <Row key={i} k={b.kind === "device" ? "Cihaz yasaklı" : "IP yasaklı"} v={`${b.reason || ""} ${b.expiresAt ? "· " + day(b.expiresAt) : "· süresiz"}`} />)
              ) : (
                <Empty t="Bu cihaz ya da IP yasaklı değil. Yasaklamak için: Cihaz / IP yasağı sayfası." />
              )}
            </Box>
          </>
        )}

        {tab === "hareket" && (
          <div className="col-12 mb-4">
            <div className="badu-tile">
              {recent.length ? (
                <table className="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Tarih</th>
                      <th>Tür</th>
                      <th>Kiminle</th>
                      <th style={{ textAlign: "right" }}>Coin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recent.map((h, i) => (
                      <tr key={i}>
                        <td>{dt(h.at)}</td>
                        <td>{h.type}</td>
                        <td>{h.with || "—"}</td>
                        <td style={{ textAlign: "right", fontWeight: 700, color: h.income ? "#059669" : "#DC2626" }}>
                          {h.income ? "+" : "−"}
                          {fmt(h.coin)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <Empty t="Hareket yok" />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default User360;
